<template>
  <v-app-bar app v-if="showToolbar">
    <v-app-bar-nav-icon
      v-if="!isEndCustomer"
      @click="$parent.$emit('toggle-drawer')"
    ></v-app-bar-nav-icon>
    <v-spacer></v-spacer>
    <v-img
      max-height="50"
      max-width="130"
      contain
      :src="logoUrl"
    />
    <v-spacer></v-spacer>

  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapGetters([
      'currentTheme'
    ]),
    showToolbar() {
      return !this.get(this.$route, 'meta.hideLayout')
    },
    logoUrl() {
      return _.get(this.currentTheme, 'logo') || require('@/assets/styles/themes/polygon/polygon_logo.png')
    }
  },
  methods: {
    signOut() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">
.v-app-bar__nav-icon { position: absolute !important; }
</style>
